const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Resolve blog cover image: uploaded images come back as "/api/media/.." (relative to backend)
export const resolveImg = (src) => {
  if (!src) return null;
  if (src.startsWith("/api/")) return `${BACKEND}${src}`;
  return src;
};

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};
